import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import RegisterToJoin from "./RegisterToJoin";
import LoginToJoin from "./LoginToJoin";
import useApiRequest from "@shared/hooks/common/useApiRequest";
import { InviteData } from "@features/auth/types";
import { removeLocalStorage, setLocalStorage } from "@shared/lib";
import MedenticAuthEntryPage from "@shared/ui/MedenticAuthEntryPage";
import { ErrorResponse } from "@shared/types/commonTypes";
import { Banner, BlockStack, Box, Button } from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";

function JoinForm() {
  const { GET } = useApiRequest();
  const [formMode, setFormMode] = useState("register");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { t } = useTranslation();

  const {
    data: inviteData,
    isLoading,
    isError,
    error,
  } = useQuery<InviteData, ErrorResponse>({
    queryKey: ["invite-data", token],
    queryFn: () => GET(`/api/auth/invites/${token}`),
    enabled: !!token,
  });

  useEffect(() => {
    if (!isLoading && inviteData && !isError) {
      setLocalStorage("__LAST_VISITED_C_ID", inviteData?.company?.id);
    }
  }, [isLoading, inviteData, isError]);

  const navigateToHome = () => {
    removeLocalStorage("invite_token");
    window.location.href = "/";
  };

  const renderJoinForm = () => {
    return formMode === "register" ? (
      <RegisterToJoin
        inviteData={inviteData}
        isLoading={isLoading}
        acceptWithRegisteredUser={() => {
          setFormMode("login");
        }}
      />
    ) : (
      <LoginToJoin
        inviteData={inviteData}
        acceptWithEmail={() => {
          setFormMode("register");
        }}
      />
    );
  };
  const renderErrorCard = () => {
    return (
      <MedenticAuthEntryPage
        wrapperClass="white-card-wrapper"
        footerClass="relative-auth-footer"
      >
        <Banner tone="critical">
          {error?.response?.data?.error?.display ?? "Invalid token"}
        </Banner>
        <Box paddingBlockStart={"300"} paddingBlockEnd={"1200"}>
          <BlockStack inlineAlign="start" gap={"200"}>
            <Button variant="plain" onClick={navigateToHome}>
              {t("common.gotoHome")}
            </Button>
          </BlockStack>
        </Box>
      </MedenticAuthEntryPage>
    );
  };

  return isError && !isLoading ? renderErrorCard() : renderJoinForm();
}

export default JoinForm;
